export default {"src":"/_next/static/media/draganddrop.a483dfe7.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};